export class PatternConstants {
    public static readonly phoneNumberPattern: any[] = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public static readonly npiNumberPattern: any[]=[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];  // 10 digits without any separators
}
